import moment from 'moment';
import {DATETIME_FORMAT} from './date.model';

export const IM_DF_OC_SUFFIX = '_Oc';
export const IM_DF_PNL_SUFFIX = '_Pl';
export const IM_DF_CUM_SUFFIX = '_Cum';

export class PlantRiskModel {
  asset: string;
  assetLabel: string;
  country: string;
  prData: PlantRiskDataModel[];
}

export class PlantRiskDataModel {
  cf: number;
  pmax: number;
  pnl: number;
  psched: number;
  ts: string;

  constructor(objIn: any) {
    this.cf = objIn.delta_cashflow || null;
    this.pmax = objIn.availability || 0;
    this.pnl = objIn.cashflow_asis || null;
    this.psched = objIn.psched_asis || 0;
    this.ts = objIn.timestamp
      ? moment.utc(objIn.timestamp).local().format(DATETIME_FORMAT)
      : '';
  }
}

// merged datamodel (all assets as attributes in 1 list of objects) for outage
export class PlantRiskOutageModel {
  country: string;
  outageData: any[]; // type any cuz the attributes are the asset names

  constructor(country: string) {
    this.country = country;
    this.outageData = [];
  }

}
